import React, { useState, useEffect, useRef } from "react";
import style from "css/landing.module.css";
import PartnerSwiperItem from "./partnerSwiperItem";
import CountUp from "components/common/countUp";
import { useMediaQuery } from "react-responsive";

function Partners() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });
  const partnerRef = useRef(null);
  const [isVisible, setVisible] = useState(false);
  const containerRef = useRef(null);
  const divRefs = [useRef(null), useRef(null), useRef(null)];
  const [scales, setScales] = useState([1, 1, 1]);
  const companyCnt = 89;
  const userCnt = 568676;

  const partnerList = [
    {
      type: "기업",
      img_m: "img/landing/partner/company_m.png",
      list: [
        {
          name: "hynix",
          img: "img/landing/partner/hynix.webp",
        },
        {
          name: "lgd",
          img: "img/landing/partner/lgd.webp",
        },
        {
          name: "samsunglife",
          img: "img/landing/partner/samsunglife.webp",
        },
        {
          name: "hallym",
          img: "img/landing/partner/hallym.webp",
        },
        {
          name: "hankook_tire",
          img: "img/landing/partner/hankook_tire.webp",
        },
        {
          name: "cj",
          img: "img/landing/partner/cj.webp",
        },
        {
          name: "daesang",
          img: "img/landing/partner/daesang.webp",
        },
        {
          name: "coupang",
          img: "img/landing/partner/coupang.webp",
        },
        {
          name: "hd",
          img: "img/landing/partner/hd.webp",
        },
        {
          name: "hyundai",
          img: "img/landing/partner/hyundai.webp",
        },
      ],
    },
    {
      type: "관공서",
      img_m: "img/landing/partner/government_m.png",
      list: [
        {
          name: "president",
          img: "img/landing/partner/president.webp",
        },
        {
          name: "mofa",
          img: "img/landing/partner/mofa.webp",
        },
        {
          name: "kobank",
          img: "img/landing/partner/kobank.webp",
        },
        {
          name: "pss",
          img: "img/landing/partner/pss.png",
        },
        {
          name: "nts",
          img: "img/landing/partner/nts.webp",
        },
        {
          name: "jeonbuk",
          img: "img/landing/partner/jeonbuk.webp",
        },
        {
          name: "lh",
          img: "img/landing/partner/lh.webp",
        },
        {
          name: "gangwon",
          img: "img/landing/partner/gangwon.webp",
        },
        {
          name: "kic",
          img: "img/landing/partner/kic.webp",
        },
        {
          name: "khnp",
          img: "img/landing/partner/khnp.webp",
        },
      ],
    },
    {
      type: "교육기관",
      img_m: "img/landing/partner/education.png",
      list: [
        {
          name: "hanyang",
          img: "img/landing/partner/hanyang.webp",
        },
        {
          name: "wdu",
          img: "img/landing/partner/wdu.webp",
        },
        {
          name: "bdu",
          img: "img/landing/partner/bdu.webp",
        },
        {
          name: "cju",
          img: "img/landing/partner/cju.webp",
        },
        {
          name: "anyang",
          img: "img/landing/partner/anyang.webp",
        },
        {
          name: "busanjinhak",
          img: "img/landing/partner/busanjinhak.webp",
        },
        {
          name: "hancom",
          img: "img/landing/partner/hancom.webp",
        },
        {
          name: "purple",
          img: "img/landing/partner/purple.webp",
        },
        {
          name: "askwhy",
          img: "img/landing/partner/askwhy.webp",
        },

        {
          name: "dsu",
          img: "img/landing/partner/dsu.webp",
        },
      ],
    },
  ];
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => setVisible(entry.isIntersecting));
    });

    if (partnerRef.current) {
      observer.observe(partnerRef.current);
    }

    return () => {
      if (partnerRef.current) {
        observer.unobserve(partnerRef.current);
      }
    };
  }, []);

  return (
    <div className={style.partners_wrap} ref={partnerRef}>
      <div
        className={style.partners_title_wrap}
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible
            ? "translate3d(0, 0, 0)"
            : "translate3d(0, 50%, 0)",
          transition:
            "opacity 1.5s cubic-bezier(0, 0, 0.2, 1), transform 1.5s cubic-bezier(0, 0, 0.2, 1)",
          transitionDelay: "0.5s",
        }}
      >
        <div className={style.partners_title}>
          <span>Riv</span>와 함께해 온 기업
        </div>
        <div className={style.partners_text}>
          2012년부터 리브테크놀로지와{"\n"} 많은 기업들이 함께했습니다.
        </div>
      </div>

      <div
        className={style.partners_counting_wrap}
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible
            ? "translate3d(0, 0, 0)"
            : "translate3d(0, 50%, 0)",
          transition:
            "opacity 1.5s cubic-bezier(0, 0, 0.2, 1), transform 1.5s cubic-bezier(0, 0, 0.2, 1)",
          transitionDelay: "0.5s",
        }}
      >
        {!isMobile && !isTablet ? (
          <div className={style.partners_vendor_box}>
            <div className={style.partners_vendor_wrap}>
              <p className={style.partners_vendor_cnt}>5</p>
              <div className={style.partners_vendor_logo_wrap}>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/zoom.webp"
                    }
                    alt="zoom"
                  />
                </div>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/webex.webp"
                    }
                    alt="webex"
                  />
                </div>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/poly.webp"
                    }
                    alt="poly"
                  />
                </div>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/cisco.webp"
                    }
                    alt="cisco"
                  />
                </div>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/pexip.webp"
                    }
                    alt="pexip"
                  />
                </div>
              </div>
            </div>
            <div className={style.partners_cnt_label}>연동 VENDOR</div>
          </div>
        ) : (
          <div className={style.partners_vendor_box}>
            <div className={style.partners_vendor_wrap}>
              <div className={style.partners_vendor_text}>
                <div className={style.partners_cnt_label}>연동 VENDOR</div>
                <p className={style.partners_vendor_cnt}>5</p>
              </div>

              <div className={style.partners_vendor_logo_wrap}>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/zoom_m.png"
                    }
                    alt="zoom"
                  />
                </div>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/webex_m.png"
                    }
                    alt="webex"
                  />
                </div>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/poly_m.png"
                    }
                    alt="poly"
                  />
                </div>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/cisco_m.png"
                    }
                    alt="cisco"
                  />
                </div>
                <div className={style.partners_vendor_logo_box}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/landing/vendor/pexip_m.png"
                    }
                    alt="pexip"
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {!isMobile && !isTablet ? (
          <>
            <div className={style.partners_company_box}>
              <div className={style.partners_cnt_wrap}>
                <p className={style.partners_cnt}>
                  {/* {companyCnt.toLocaleString()} */}
                  <CountUp
                    init={isVisible}
                    ref={partnerRef}
                    target={companyCnt}
                    duration={5000}
                  />
                  <span>+</span>
                </p>
              </div>
              <div className={style.partners_cnt_label}>사용 기관</div>
            </div>
            <div className={style.partners_user_box}>
              <div className={style.partners_cnt_wrap}>
                <p className={style.partners_cnt}>
                  {/* {userCnt.toLocaleString()} */}
                  <CountUp
                    init={isVisible}
                    ref={partnerRef}
                    target={userCnt}
                    duration={5000}
                  />
                  <span>+</span>
                </p>
              </div>
              <div className={style.partners_cnt_label}>연 사용 인원</div>
            </div>
          </>
        ) : (
          <div className={style.partners_count_box_group}>
            <div className={style.partners_company_box}>
              <div className={style.partners_cnt_label}>사용 기관</div>
              <div className={style.partners_cnt_wrap}>
                <p className={style.partners_cnt}>
                  {/* {companyCnt.toLocaleString()} */}
                  <CountUp
                    init={isVisible}
                    ref={partnerRef}
                    target={companyCnt}
                    duration={2000}
                  />
                  <span>+</span>
                </p>
              </div>
            </div>
            <div className={style.partners_user_box}>
              <div className={style.partners_cnt_label}>연 사용 인원</div>
              <div className={style.partners_cnt_wrap}>
                <p className={style.partners_cnt}>
                  {/* {userCnt.toLocaleString()} */}
                  <CountUp
                    init={isVisible}
                    ref={partnerRef}
                    target={userCnt}
                    duration={2000}
                  />
                </p>
              </div>
            </div>
          </div>
        )}
      </div>

      <div className={style.parners_list_wrap} ref={containerRef}>
        {partnerList.map((item, index) => (
          <PartnerSwiperItem
            item={item}
            key={index}
            ref={divRefs[index]}
            index={index + 1}
          />
        ))}
      </div>
    </div>
  );
}

export default Partners;
